import React from 'react';

export default function LanguagesFilter({
  languages, // Array of available languages { label, value }
  selectedLanguage, // Single selected language value
  onLanguageChange, // Function to call when selection changes
}) {

  const handleSelectChange = (event) => {
    onLanguageChange(event.target.value);
  };

  return (
    <div className="languages-filter-select-container">
      <select value={selectedLanguage} onChange={handleSelectChange}>
        <option value="">All Languages</option> {/* Option to select all */}
        {languages.map(lang => (
          <option key={lang.value} value={lang.value}>
            {lang.label}
          </option>
        ))}
      </select>
    </div>
  );
} 